// extracted by mini-css-extract-plugin
module.exports = {"loadingStatus":"SettingsForm_loadingStatus__2vYaN"};